import React, {useContext} from 'react';
import OleCountrySelect from './OleCountrySelect';
import LinkOptionContext from '../contexts/LinkOptionContext';
import { useState } from 'react';
import './styles/header.css'
import { REACT_APP_COUNTRY_DEPLOY } from '../config';

function Header ({ paymentType, language, showLogo, logoUrl }: { paymentType: string, language: string, showLogo: boolean, logoUrl?: string }) {
    const { option, changeOption, canPay = true } = useContext(LinkOptionContext);
    const [selectedOption, setSelectedOption] = useState(localStorage.getItem('selectedLinkOption') || 'payment');
    const activeOption = option ?? selectedOption;
    const hideStyle = { display: 'none' };

    const showStyleMX = { display: 'block', backgroundImage: 'url("../logo_ole_sp.png")', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'left center' };
    const showStyleBR = { display: 'block', backgroundImage: 'url("../logo_official.png")' };
    const showStyleBase = { display: 'block', backgroundImage: 'url("../logo_ole.svg")', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'left center', width: '99px', height: '40px' };

    const defaultShowStyle = REACT_APP_COUNTRY_DEPLOY === 'MX' ? showStyleMX : REACT_APP_COUNTRY_DEPLOY === 'BR' ? showStyleBR : showStyleBase;
    const handleChangeOption = (nextOption: string) => {
        if (nextOption === 'payment' && !canPay) return;
        setSelectedOption(nextOption);
        changeOption(nextOption);
    };
    const paymentOptionClass = `option-payment ${activeOption === 'payment' ? 'active' : 'inactive'}${canPay ? '' : ' disabled'}`;

    return (
        <div className={'app-header-' + paymentType}>
            <div className='main'>
                <div
                    className={'logo-' + paymentType}
                    style={!showLogo ? hideStyle : logoUrl ? { display: 'block', width: '254px', height: '36px' } : defaultShowStyle}
                >
                    {showLogo && logoUrl && (
                        <img src={logoUrl} alt='logo' style={{ height: '36px', objectFit: 'contain', display: 'block' }} />
                    )}
                </div>
                <div className={'countries-' + paymentType}>< OleCountrySelect defaultValue={language} /></div>
            </div>
            <div className={'options-' + paymentType}>
                {language === 'en' && (
                <>
                    <div className={paymentOptionClass} aria-disabled={!canPay} onClick={() => handleChangeOption('payment')}>Make a Payment</div>
                    <div className={activeOption === 'update' ? 'option-update active' : 'option-update inactive'} onClick={() => handleChangeOption('update')}>Only update Card</div>
                </>)}
                {language === 'es' && (
                <>
                    <div className={paymentOptionClass} aria-disabled={!canPay} onClick={() => handleChangeOption('payment')}>Realizar pago</div>
                    <div className={activeOption === 'update' ? 'option-update active' : 'option-update inactive'} onClick={() => handleChangeOption('update')}>Actualizar tarjeta</div>
                </>)}
                {language === 'pt' && (
                <>
                    <div className={paymentOptionClass} aria-disabled={!canPay} onClick={() => handleChangeOption('payment')}>Fazer pagamento</div>
                    <div className={activeOption === 'update' ? 'option-update active' : 'option-update inactive'} onClick={() => handleChangeOption('update')}>Atualizar apenas o cartão</div>
                </>)}
            </div>
        </div>
    )
}

export default Header;